import { Platform, StyleSheet } from 'react-native';

import { COLOR } from 'utils/colors';
import { isTabletOrWeb, widthPercentageToDP } from 'utils/responsiveness';

import { CAST_ITEM_SIZE_WEB } from 'components/CustomButtons/RibbonTouchable/styles';

const styles = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: isTabletOrWeb ? 16 : 8,
    },
    image: {
        width: Platform.select({
            web: CAST_ITEM_SIZE_WEB,
            default: widthPercentageToDP(104, 132),
        }),
        aspectRatio: 1,
        backgroundColor: COLOR.COD_GRAY_LIGHT,
        borderRadius: widthPercentageToDP(104, 132, 176),
        marginBottom: widthPercentageToDP(4, 6, 8),
    },
    actorName: {
        width: Platform.select({
            web: CAST_ITEM_SIZE_WEB,
            default: widthPercentageToDP(104, 132),
        }),
        fontSize: 14,
    },
});

export default styles;
